import { combineReducers } from 'redux';
import initialization from './initialization.reducer';

const reducer = combineReducers({
	initialization
});

export default reducer;
